import { render, staticRenderFns } from "./RegistPanelComponent.vue?vue&type=template&id=933028fe&"
import script from "./RegistPanelComponent.vue?vue&type=script&lang=ts&"
export * from "./RegistPanelComponent.vue?vue&type=script&lang=ts&"
import style0 from "./RegistPanelComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContent,VRow})
